<template>
  <PageWrapper>
    <PageContent v-if="isDevelopment">

      <TabbedPortlet>
        <TabbedPortletHead>
          <li class="nav-item">
            <a
              href=""
              class="nav-link active">Lab 1</a>
          </li>
          <li class="nav-item">
            <a
              href=""
              class="nav-link">Lab 2</a>
          </li>
        </TabbedPortletHead>
        <TabbedPortletBody>
          <h1>CHKEditor <span id="word-count"></span></h1>
          <Editor
            :height="150"
            v-model="content"
            :editorConfig="editorConfig"
            :showDebugger="true" />
          <span></span>
        </TabbedPortletBody>
      </TabbedPortlet>

    </PageContent>
  </PageWrapper>
</template>

<script>
import { mapState } from 'vuex'
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import PageContent from '@/components/_shared/PageContent.vue'
import TabbedPortlet from '@/components/_shared/tabbed-portlet/TabbedPortlet.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import Editor from '@/components/_shared/Editor.vue'

export default {
  name: 'About',
  data () {
    return {
      content: ''
    }
  },
  components: {
    PageWrapper,
    PageContent,
    TabbedPortlet,
    TabbedPortletHead,
    TabbedPortletBody,
    Editor
  },
  computed: { ...mapState(['isDevelopment']) }
}
</script>

<style lang="scss" scoped>
.custom-height {
  height: 100%;
}
</style>
